import { api } from "@/redux/api";

import {
	ColumnTemplate,
	ColumnTemplateResponse,
	ColumnTemplateResponseSchema,
	ColumnTemplateSchema,
	CreateColumnTemplate,
	UpdateColumnTemplate,
} from "../../pages/List/schema/column-template";
import {
	RunPromptRequest,
	RunPromptRequestSchema,
	RunPromptResponse,
	RunPromptResponseSchema,
} from "../../pages/List/schema/columnValue";

export const columnApi = api.injectEndpoints({
	endpoints: (builder) => ({
		creatCustomColumnTemplate: builder.mutation<ColumnTemplate, CreateColumnTemplate>({
			query: (body) => ({
				url: `/columns`,
				method: "POST",
				body,
				responseSchema: ColumnTemplateSchema,
			}),
			invalidatesTags: ["ColumnTemplate"],
		}),
		updateColumnTemplate: builder.mutation<ColumnTemplate, UpdateColumnTemplate>({
			query: ({ id, ...body }) => ({
				url: `/columns/${id}`,
				method: "PATCH",
				body,
				responseSchema: ColumnTemplateSchema,
			}),
			invalidatesTags: ["ColumnTemplate"],
		}),
		deleteColumnTemplate: builder.mutation<ColumnTemplate, number>({
			query: (id) => ({
				url: `/columns/${id}`,
				method: "DELETE",
				responseSchema: ColumnTemplateSchema,
			}),
			invalidatesTags: ["ColumnTemplate"],
		}),
		getCustomColumnTemplates: builder.query<ColumnTemplateResponse, void>({
			query: () => ({
				url: `/columns`,
				method: "GET",
				responseSchema: ColumnTemplateResponseSchema,
			}),
			providesTags: ["ColumnTemplate"],
		}),
		runPrompt: builder.mutation<RunPromptResponse, RunPromptRequest>({
			query: (body) => ({
				url: `columns/run-prompt`,
				method: "POST",
				body,
				requestSchema: RunPromptRequestSchema,
				responseSchema: RunPromptResponseSchema,
			}),
		}),
	}),
});

export const {
	useCreatCustomColumnTemplateMutation,
	useUpdateColumnTemplateMutation,
	useGetCustomColumnTemplatesQuery,
	useDeleteColumnTemplateMutation,
	useRunPromptMutation,
} = columnApi;
export const columnApiReducer = columnApi.reducer;
export const columnApiMiddleware = columnApi.middleware;
